import { useEffect, useState } from 'react';
import { showAuthPopup } from 'shared/auth';
import { SiteLayoutComponent, SiteSection } from 'shared/components/site-layout';
import { AuthService, UserClaims } from 'shared/mechanics/auth';

export const DiscountsPage = () => {
	const [contentRef, setContentRef] = useState<HTMLIFrameElement | null>(null)

	const userAuthorization = AuthService.resolveUserAuthorization();
	const haveClaim = userAuthorization.haveClaim(UserClaims.HAVE_SUBSCRIPTION);
	if (!haveClaim)
	{
		showAuthPopup({ title: "Риалтейм дисконты" });
	}

	const src = "https://docs.google.com/spreadsheets/d/e/2PACX-1vQPM0T2QZA3UhHrl25lRa6556B0YW4w2BkHAk4FIHyvnBH8-G3hN3vl5X1kSaNkgVz4Ww8FEtrTSEUG/pubhtml?widget=true&amp;headers=false";

	useEffect(
		() => {
			const interval = setInterval(() => {
				if (contentRef)
					contentRef.src = src;
			}, 15 * 1_000)
			return () => { clearInterval(interval) };
		},
		[contentRef]);

	return (
		<SiteLayoutComponent activeSection={SiteSection.None}>
			{
				haveClaim
					? <iframe ref={cmp => setContentRef(cmp)} src={src} style={{ flex: "1" }}></iframe>
					: null
			}
		</SiteLayoutComponent>
	);
};